import React from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../auth/session";
import { FiMessageSquare, FiArrowRight, FiLock } from "react-icons/fi";

export default function Login() {
  const auth = useAuth();
  // Set by the front door when a sign-in it started does not complete:
  // cancelled at Cognito, expired, or not started from this browser.
  const [searchParams] = useSearchParams();
  const signInFailed = Boolean(searchParams.get("error"));

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      <div className="flex items-start justify-center pt-32 min-h-screen px-4">
        <div className="max-w-lg w-full mx-auto">
          <div className="text-center space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center bg-blue-100 text-blue-800 px-3 py-1.5 rounded-full text-xs font-medium">
                <FiMessageSquare className="w-3 h-3 mr-1.5" />
                AI-Powered Payment Assistant
              </div>
              <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                Welcome to
                <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                  {" "}
                  TNSPay IQ
                </span>
              </h1>
              <p className="text-lg text-gray-600">
                Expert guidance for payment solutions
              </p>
            </div>

            {/* Login Card */}
            <div className="bg-white rounded-xl shadow-lg p-6 space-y-4">
              {signInFailed && (
                <p role="alert" className="text-sm text-red-700 text-center">
                  Sign-in didn't finish. Please try again.
                </p>
              )}
              <button
                onClick={() => auth.signinRedirect()}
                className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-3 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 transition-colors flex items-center justify-center space-x-2"
              >
                <FiLock className="w-4 h-4" />
                <span>Sign In</span>
              </button>

              <p className="text-xs text-gray-500 text-center">
                Need access? Contact{" "}
                <a
                  href="mailto:dhore@tnsi.com"
                  className="text-blue-600 hover:text-blue-700"
                >
                  dhore@tnsi.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
